import {type ComponentType} from 'react'

import {useComlinkRouteHandler} from '../hooks/useComlinkRouteHandler'

export const ComlinkRouteHandler: ComponentType = () => {
  useComlinkRouteHandler()
  return null
}
